const { INTERNAL_PATHS, EXTERNAL_LINKS } = require("routes/paths");

export const LINK_LIST = [
  {
    path: INTERNAL_PATHS.GUARANTEE,
    label: "What does your guarantee cover?"
  },
  {
    path: INTERNAL_PATHS.REFERRAL_PROGRAM,
    label: "How can I earn $5 for sharing?"
  },
  {
    path: EXTERNAL_LINKS.MARKETPLACE_ZENDESK,
    label: "More FAQs"
  }
];
